import { render, staticRenderFns } from "./SegregationButtonToggle.vue?vue&type=template&id=4b3c2f47&"
import script from "./SegregationButtonToggle.vue?vue&type=script&lang=ts&"
export * from "./SegregationButtonToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SegregationButtonToggle.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports